export const DEFAULT_AVATAR = "/img/default-avatar.svg"